import {
  useCallback, useEffect,
} from 'react';
import { useDispatch } from 'react-redux';
import { deviceInfoUpdateScreenWidth } from '~/store/frontendState/deviceInfo/deviceInfo.actionCreator';

export const useScreenAndDeviceDetect = () => {
  const dispatch = useDispatch();
  const onResize = useCallback(() => {
    dispatch(deviceInfoUpdateScreenWidth(window.innerWidth));
  }, [dispatch]);

  const screenAndDeviceDetect = useCallback(
    () => {
      window.addEventListener('resize', onResize);
      return () => {
        window.removeEventListener('resize', onResize);
      };
    },
    [onResize],
  );

  useEffect(() => {
    screenAndDeviceDetect();
  }, [screenAndDeviceDetect]);
};
